import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ContentService } from 'src/app/modules/cam/services/content.service';
import { NgIf } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AdminInfoComponent } from '../../components/admin-info/admin-info.component';
import { StopOnboardingComponent } from '../../../../shared/components/stop-onboarding/stop-onboarding.component';

@Component({
    selector: 'app-admin-signup',
    templateUrl: './admin-signup.component.html',
    styleUrls: ['../signup.component.scss', './admin-signup.component.scss'],
    imports: [NgIf, ReactiveFormsModule, FormsModule, AdminInfoComponent, StopOnboardingComponent]
})
export class AdminSignupComponent implements OnInit, OnDestroy {
  fetchMatchS: boolean = false;
  matchedEmail: string = '';
  content: any;
  private destroy$ = new Subject<void>();
  constructor(private contentService: ContentService) {
    this.contentService.loadContent()
  }
  ngOnInit(): void {
    this.contentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
      });

      
  }

  fetchMatchStatus(data: any) {
    this.fetchMatchS = data.exists;
    this.matchedEmail = data.email;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
